// src/components/ReceiptModal.jsx
import React from "react";
import "./ReceiptModal.css";
import apnargharLogo from "./apnaghar.png"; // ✅ import your logo

const ReceiptModal = ({ listing, onClose }) => {
  if (!listing) return null;

  return (
    <div className="receipt-overlay">
      <div className="receipt-card">
        {/* Close button (top-right corner) */}
        <button className="close-icon" onClick={onClose}>✖</button>

        <h2>LISTING RECEIPT</h2>
        <hr />
       <p><strong>Listing ID:</strong> {listing.id}</p>
<p><strong>Name:</strong> <span className="capitalize">{listing.pgName}</span></p>
<p><strong>Phone Number:</strong> <span className="capitalize">{listing.whatsapp}</span></p>
<p><strong>Plan:</strong> <span className="capitalize">{listing.plan || "Free"}</span></p>

        {/* Watermark */}
        <div className="receipt-watermark">
          <img src={apnargharLogo} alt="Watermark" />
        </div>
      </div>
    </div>
  );
};

export default ReceiptModal;
